<template>
    <div class="a-input-cvv input-cvv-wrapper">
        <input
            v-model="localValue"
            v-mask="mask"
            :id="elementId"
            :class="disabledClass"
            :disabled="isDisabled"
            :placeholder="placeholder"
            :readonly="isReadOnly"
            :at-a-input-cvv="atAttribute"
            :autocomplete="autocomplete"
            type="password"
            inputmode="decimal"
            class="input-cvv"
            @paste="handlePaste"
            @keypress="handleKeypress"
            @blur="handleBlur"
        />
    </div>

</template>

<script>

export default {
    name: 'AInputCvv',
    props: {
        /**
         * Set id attribute
         */
        elementId: {
            type: String,
            default: null
        },
        /**
         * Set placeholder for input
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * Set disabled attribute
         */
        isDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Set readonly attribute
         */
        isReadOnly: {
            type: Boolean,
            default: false
        },
        /**
         * Set input value
         */
        value: {
            type: String,
            default: ''
        },
        /**
         * Set an autocomplete attribute
         */
        autocomplete: {
            type: String,
            default: 'off'
        },
        /**
         * Locator for automating tests
         */
        atAttribute: {
            type: String,
            default: ''
        },
        /**
         * Set mask rules
         */
        mask: {
            type: String,
            default: '###'
        },
        /**
         * Set mask rules
         */
        allowedCharacters: {
            type: [String, RegExp],
            default: ''
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        disabledClass() {
            return this.isDisabled ? 'input-cvv--disabled' : null;
        }
    },
    methods: {
        handleBlur(e) {
            this.$emit('blur', e);
        },
        handleKeypress(e) {
            if (!this.allowedCharacters) return;
            if (!e.key.match(this.allowedCharacters)) {
                e.preventDefault();
            }
        },
        handlePaste(e) {
            if (!this.allowedCharacters) return;
            if (!(e.clipboardData || window.clipboardData).getData('text').match(this.allowedCharacters)) {
                e.preventDefault();
            }
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
